/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../../../components/ui/button/Buttons";

/** Configuration files */
import { editScopesConfig } from "./ContractScopes.formfield.config";
import { ContractContext } from "../../../../../../../utils/context/ContractContext";
import { removeFormFields } from "../../../../../../../utils/formFieldUtils/ManageFields";
import { useContractDepartmentUpdateCostFromScopesMutation, useUpdateContractScopeMutation } from "../../../../../../../app/services/contractAPI";
import ToastService from "../../../../../../../services/toastService/ToastService";

const EditScopes = ({ onClose, rowData, reloadScopes }) => {
  
  const EditScopetRef = useRef();
  const { contractData,contractId } = useContext(ContractContext);

  const [specificationForm, setSpecificationForm] = useState(editScopesConfig);

  const [editContractScope, {
    isSuccess: iseditContractScope,
    data: editContractScopeData,
  },] = useUpdateContractScopeMutation();

  const [contractDepartmentUpdateCostFromScopes] = useContractDepartmentUpdateCostFromScopesMutation();

  const parseDate = (value) => {
    if (!value) return null;
    const dateOnly = value.split("T")[0];
    const date = new Date(dateOnly);
    return isNaN(date) ? null : date;
  };

  useEffect(() => {
    if (!contractData) return;
    let updatedConfig = { ...editScopesConfig };
    if (contractData?.lContractTypeKey !== 1) {
      updatedConfig = removeFormFields(editScopesConfig, [
        "shippingCompany",
        "strackingNumber"
      ]);
    }
    updatedConfig.initialState = {
      dtDateEffective: parseDate(rowData?.startDate),
      dtEndDate: parseDate(rowData?.endDate),
      nCost: rowData?.nCost || "0",

      shippingCompany:
        rowData?.bUPSTrackingNumber === true ? "ups" : "fedex",

      strackingNumber: rowData?.sTrackingNumber
    };
    setSpecificationForm(updatedConfig);
  }, [rowData, contractData]);

  const handleSaveClick = () => {
    const formData = EditScopetRef.current.getFormData();

    const formatDateToISO = (date) => {
      if (!date) return null;
      return new Date(date).toISOString();
    };

    if (formData) {
      const req = {
        plContractScopeKey: rowData?.lContractScopeKey,
        pdtScopeAdded: formatDateToISO(formData?.dtDateEffective),
        pdtScopeRemoved: formatDateToISO(formData?.dtEndDate),
        pnCost: formData.nCost,
        pbUPS: formData?.shippingCompany === "ups" ? true : false,
        psTrackingNumber: formData?.strackingNumber
      };
      editContractScope(req);
    }
  };

  const resetForm = () => {
    const formData = { ...specificationForm };
    formData.initialState = {};
    setSpecificationForm(formData);
  };

  useEffect(() => {
    if (iseditContractScope && editContractScopeData) {
      if (editContractScopeData?.errorMessage) {
        contractDepartmentUpdateCostFromScopes({ plContractKey: Number(contractId), plDepartmentKey: rowData?.lDepartmentKey });
        ToastService.success(editContractScopeData?.errorMessage);
        if (typeof reloadScopes === "function") {
          reloadScopes();  
        }
        resetForm();
        onClose();
      }
    }
  }, [iseditContractScope, editContractScopeData]);

  return (
    <>
      <div className="row">
        <FormCreator ref={EditScopetRef} config={specificationForm} />
        <div className="d-flex justify-content-end gap-3">
          <Buttons
            buttonText="Save"
            onClick={handleSaveClick}
            buttonTypeClassName="btn blue-btn"
            titleText="Unassign Selected Items"
          />
          <Buttons
            buttonText="Cancel"
            onClick={onClose}
            buttonTypeClassName="btn dark-btn"
            titleText="Unassign Selected Items"
          />
        </div>
      </div>
    </>
  );
};
export default EditScopes;
